import { useRef, useState } from 'react';
import backIcon from '../../assets/images/arrow_left.svg';
import AdvancedSearch from './AdvancedSearch';
import Image from '../../atoms/Image';
import Text from '../../atoms/Text';
import FilterMobile from './Filter';
import './styles.scss';

export interface IMobileFilterProps {
  setValue: (data: any) => void;
  initialData?: any;
}

interface ISearchTableProps {
  renderChildren(
    search: string,
    onChildMount: (data: IMobileFilterProps) => void,
    onBack: () => void
  ): JSX.Element;
  renderFilterOptions(data: IMobileFilterProps): JSX.Element;
  tableTitle: string;
  filterTitle: string;
  filterIcon: string;
  onBack(): void;
}

const SearchTable = ({
  tableTitle,
  filterTitle,
  filterIcon,
  renderChildren,
  renderFilterOptions,
  onBack,
}: ISearchTableProps) => {
  const [search, setSearch] = useState('');
  const [isActiveFilter, setIsActiveFilter] = useState(false);
  const selectOption = useRef<any>(null);
  const initData = useRef<any>(null);

  const onChildMount = (data: IMobileFilterProps) => {
    selectOption.current = data.setValue;
    initData.current = data.initialData;
  };

  const onSearch = (value: string) => {
    setSearch(value);
  };

  const toggleFilter = () => {
    setIsActiveFilter(!isActiveFilter);
  };

  const FilterOptions = renderFilterOptions({
    setValue: selectOption.current,
    initialData: initData.current,
  });

  return (
    <div className='search_table'>
      <div className='search_table__header'>
        <div className='search_table__header__title'>
          <div className='search_table__header__title__back_icon'>
            <Image size='m' src={backIcon} onClick={onBack} />
          </div>
          <Text size={16} className='search_table__header__title__text'>
            {tableTitle}
          </Text>
        </div>
      </div>
      <div className='search_table__content'>
        <AdvancedSearch
          search={search}
          handleSearch={onSearch}
          active={isActiveFilter}
          toggle={toggleFilter}
          icon={filterIcon}
        />
        <div className='search_table__content__table'>
          {renderChildren(search, onChildMount, onBack)}
          {isActiveFilter && (
            <FilterMobile
              title={filterTitle}
              toogleFilter={toggleFilter}
              FilterOptions={FilterOptions}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchTable;
